var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 7A7.2 7.2 0 0 0 10 1.5C7 1.5 3.7 3.2 2.8 7c-1 4.3 1.7 8 4 10.3a4.5 4.5 0 0 0 6.3 0c2.4-2.3 5-6 4-10.3ZM10 11.2A2.6 2.6 0 1 1 10 6a2.6 2.6 0 0 1 0 5.2Z",
    fill: "#34544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.60537f3712b9513b50d783438acbd938.svg";
export { ForwardRef as ReactComponent };